// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/variable/pretendardvariable.min.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * 카리아카 공통 디자인 시스템.
 * styled-components는 uiTokens.ts를, 기존 Bootstrap 화면은 아래 동일 토큰을 사용한다.
 * 업무 화면에만 적용해 랜딩·외부 결제·전체화면 수업의 독립 디자인을 유지한다.
 */

:root {
  --cari-primary: #3B82F6;
  --cari-primary-hover: #2563EB;
  --cari-primary-active: #1D4ED8;
  --cari-primary-soft: #EAF1FE;
  --cari-surface: #FFFFFF;
  --cari-canvas: #F7F8F9;
  --cari-border: #E9EBED;
  --cari-border-strong: #C9CDD3;
  --cari-text: #1B1D1F;
  --cari-text-muted: #73787E;
  --cari-radius-control: 10px;
  --cari-radius-card: 16px;
  --cari-radius-dialog: 20px;
  --cari-focus-ring: 0 0 0 3px rgba(59, 130, 246, 0.2);
  --cari-page-gutter: clamp(16px, 2vw, 24px);
  --cari-shadow: 0 2px 8px rgba(27, 29, 31, 0.04);
  --cari-shadow-lg: 0 12px 32px rgba(27, 29, 31, 0.12);
}

body {
  font-family: 'Pretendard Variable', Pretendard, 'Pretendard Regular',
    -apple-system, BlinkMacSystemFont, system-ui, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.cari-workspace {
  --bs-primary: var(--cari-primary);
  --bs-primary-rgb: 59, 130, 246;
  --bs-link-color: var(--cari-primary);
  --bs-link-hover-color: var(--cari-primary-hover);
  --bs-border-radius: var(--cari-radius-control);
  --bs-border-radius-sm: 8px;
  --bs-border-radius-lg: var(--cari-radius-card);
  --bs-border-radius-xl: var(--cari-radius-dialog);
  --bs-body-font-family: 'Pretendard Variable', Pretendard, system-ui, sans-serif;
  color: var(--cari-text);
}

/* Keyboard focus stays visible without replacing validation colors on text fields. */
.cari-workspace :where(button, a, input, select, textarea, [tabindex="0"]):focus-visible {
  outline: 2px solid var(--cari-primary);
  outline-offset: 2px;
}

.cari-workspace :where(.form-control, .form-select) {
  min-height: 40px;
  border-radius: var(--cari-radius-control);
  border-color: var(--cari-border-strong);
}
.cari-workspace :where(.form-control, .form-select):focus {
  box-shadow: var(--cari-focus-ring);
}
.cari-workspace :where(.btn) {
  min-height: 40px;
  border-radius: var(--cari-radius-control);
  font-weight: 600;
  transition: background-color 150ms ease, border-color 150ms ease;
}
.cari-workspace :where(.btn-sm) { min-height: 32px; }
.cari-workspace :where(.btn-lg) { min-height: 44px; }
.cari-workspace :where(.btn-primary) {
  --bs-btn-bg: var(--cari-primary);
  --bs-btn-border-color: var(--cari-primary);
  --bs-btn-hover-bg: var(--cari-primary-hover);
  --bs-btn-hover-border-color: var(--cari-primary-hover);
  --bs-btn-active-bg: var(--cari-primary-active);
  --bs-btn-active-border-color: var(--cari-primary-active);
  --bs-btn-disabled-bg: var(--cari-border);
  --bs-btn-disabled-border-color: var(--cari-border);
  --bs-btn-disabled-color: var(--cari-text-muted);
}
.cari-workspace :where(.btn-outline-primary) {
  --bs-btn-color: var(--cari-primary);
  --bs-btn-border-color: var(--cari-primary);
  --bs-btn-hover-bg: var(--cari-primary);
  --bs-btn-hover-border-color: var(--cari-primary);
}
.cari-workspace :where(.card, .panel) {
  border-radius: var(--cari-radius-card);
  border: 1px solid var(--cari-border);
  box-shadow: var(--cari-shadow);
}
.cari-workspace :where(.modal-content) {
  border-radius: var(--cari-radius-dialog);
  border: 1px solid var(--cari-border);
  box-shadow: var(--cari-shadow-lg);
}
.cari-workspace :where(.dropdown-menu, .popover) {
  border-radius: var(--cari-radius-control);
  border-color: var(--cari-border);
  box-shadow: var(--cari-shadow-lg);
}
.cari-workspace :where(.badge) { border-radius: 999px; font-weight: 600; }
.cari-workspace :where(.table) { --bs-table-color: var(--cari-text); border-color: var(--cari-border); }
.cari-workspace :where(.table > thead th, .table > thead td) {
  background: var(--cari-canvas);
  color: #464C52;
  font-weight: 600;
  border-bottom: 1px solid var(--cari-border);
}
.cari-workspace :where(.table-hover > tbody > tr:hover > *) { background: var(--cari-primary-soft); }
.cari-workspace :where(.form-check-input:checked, .progress-bar, .page-item.active .page-link) {
  background-color: var(--cari-primary);
  border-color: var(--cari-primary);
}
.cari-workspace :where(.form-check-input:focus) { box-shadow: var(--cari-focus-ring); }
.cari-workspace :where(.page-link) { color: var(--cari-primary); }
.cari-workspace :where(.page-item.active .page-link) { color: var(--cari-surface); }

.cari-workspace ::-webkit-scrollbar { width: 8px; height: 8px; }
.cari-workspace ::-webkit-scrollbar-thumb {
  background: var(--cari-border-strong);
  border-radius: 999px;
  border: 2px solid transparent;
  background-clip: content-box;
}
.cari-workspace ::-webkit-scrollbar-track { background: transparent; }

/* Reports print in document flow, independently of the on-screen scroll viewport. */
@media print {
  html:has(.cari-workspace),
  body:has(.cari-workspace),
  #root:has(.cari-workspace) {
    height: auto;
    min-height: 0;
    overflow: visible;
  }
  .cari-workspace.cari-workspace,
  .cari-workspace > .workspace-row,
  .cari-workspace > .workspace-row > .workspace-content,
  .cari-workspace .workspace-content > .main-content {
    position: static;
    display: block;
    width: 100%;
    height: auto;
    min-height: 0;
    max-height: none;
    overflow: visible;
    background: #fff;
  }
  .cari-workspace > .workspace-row > :not(.workspace-content),
  .cari-workspace .workspace-header,
  .cari-workspace-floating {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .cari-workspace.cari-workspace :where(*, *::before, *::after) {
    animation-duration: 0.01ms;
    animation-iteration-count: 1;
    transition-duration: 0.01ms;
    scroll-behavior: auto;
  }
}

/*
 * 부트스트랩(reactstrap) 모달 틀. app.min.css 가 .modal-dialog 높이를 calc(100vh - 60px) 로
 * 고정(!important)하고 가운데 정렬해서, 내용이 화면보다 길면 위쪽이 잘리고 스크롤로도 올라갈 수 없었다.
 * 같은 값을 최소 높이로 바꿔 작은 모달은 지금 위치 그대로, 긴 모달은 틀이 늘어나 바깥이 스크롤되게 한다.
 */
.modal-dialog {
  height: auto !important;
  min-height: calc(100vh - 60px);
}
`, "",{"version":3,"sources":["webpack://./src/design/cari-theme.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAGF;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;EAC5B,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,wBAAwB;EACxB,0BAA0B;EAC1B,oDAAoD;EACpD,0CAA0C;EAC1C,+CAA+C;EAC/C,oDAAoD;AACtD;;AAEA;EACE;4DAC0D;EAC1D,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,oCAAoC;EACpC,gDAAgD;EAChD,8CAA8C;EAC9C,0BAA0B;EAC1B,8CAA8C;EAC9C,gDAAgD;EAChD,+EAA+E;EAC/E,uBAAuB;AACzB;;AAEA,qFAAqF;AACrF;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,uCAAuC;AACzC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,gEAAgE;AAClE;AACA,kCAAkC,gBAAgB,EAAE;AACpD,kCAAkC,gBAAgB,EAAE;AACpD;EACE,gCAAgC;EAChC,0CAA0C;EAC1C,4CAA4C;EAC5C,sDAAsD;EACtD,8CAA8C;EAC9C,wDAAwD;EACxD,wCAAwC;EACxC,kDAAkD;EAClD,+CAA+C;AACjD;AACA;EACE,mCAAmC;EACnC,0CAA0C;EAC1C,sCAAsC;EACtC,gDAAgD;AAClD;AACA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,8BAA8B;AAChC;AACA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,iCAAiC;AACnC;AACA;EACE,yCAAyC;EACzC,gCAAgC;EAChC,iCAAiC;AACnC;AACA,iCAAiC,oBAAoB,EAAE,gBAAgB,EAAE;AACzE,iCAAiC,kCAAkC,EAAE,gCAAgC,EAAE;AACvG;EACE,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,2CAA2C;AAC7C;AACA,8DAA8D,oCAAoC,EAAE;AACpG;EACE,qCAAqC;EACrC,iCAAiC;AACnC;AACA,kDAAkD,kCAAkC,EAAE;AACtF,qCAAqC,0BAA0B,EAAE;AACjE,uDAAuD,0BAA0B,EAAE;;AAEnF,sCAAsC,UAAU,EAAE,WAAW,EAAE;AAC/D;EACE,qCAAqC;EACrC,oBAAoB;EACpB,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA,4CAA4C,uBAAuB,EAAE;;AAErE,oFAAoF;AACpF;EACE;;;IAGE,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;EACA;;;;IAIE,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;IAC3B,qBAAqB;EACvB;AACF;;AAEA;;;;EAIE;AACF;EACE,uBAAuB;EACvB,8BAA8B;AAChC","sourcesContent":["/**\n * 카리아카 공통 디자인 시스템.\n * styled-components는 uiTokens.ts를, 기존 Bootstrap 화면은 아래 동일 토큰을 사용한다.\n * 업무 화면에만 적용해 랜딩·외부 결제·전체화면 수업의 독립 디자인을 유지한다.\n */\n@import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/variable/pretendardvariable.min.css');\n\n:root {\n  --cari-primary: #3B82F6;\n  --cari-primary-hover: #2563EB;\n  --cari-primary-active: #1D4ED8;\n  --cari-primary-soft: #EAF1FE;\n  --cari-surface: #FFFFFF;\n  --cari-canvas: #F7F8F9;\n  --cari-border: #E9EBED;\n  --cari-border-strong: #C9CDD3;\n  --cari-text: #1B1D1F;\n  --cari-text-muted: #73787E;\n  --cari-radius-control: 10px;\n  --cari-radius-card: 16px;\n  --cari-radius-dialog: 20px;\n  --cari-focus-ring: 0 0 0 3px rgba(59, 130, 246, 0.2);\n  --cari-page-gutter: clamp(16px, 2vw, 24px);\n  --cari-shadow: 0 2px 8px rgba(27, 29, 31, 0.04);\n  --cari-shadow-lg: 0 12px 32px rgba(27, 29, 31, 0.12);\n}\n\nbody {\n  font-family: 'Pretendard Variable', Pretendard, 'Pretendard Regular',\n    -apple-system, BlinkMacSystemFont, system-ui, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.cari-workspace {\n  --bs-primary: var(--cari-primary);\n  --bs-primary-rgb: 59, 130, 246;\n  --bs-link-color: var(--cari-primary);\n  --bs-link-hover-color: var(--cari-primary-hover);\n  --bs-border-radius: var(--cari-radius-control);\n  --bs-border-radius-sm: 8px;\n  --bs-border-radius-lg: var(--cari-radius-card);\n  --bs-border-radius-xl: var(--cari-radius-dialog);\n  --bs-body-font-family: 'Pretendard Variable', Pretendard, system-ui, sans-serif;\n  color: var(--cari-text);\n}\n\n/* Keyboard focus stays visible without replacing validation colors on text fields. */\n.cari-workspace :where(button, a, input, select, textarea, [tabindex=\"0\"]):focus-visible {\n  outline: 2px solid var(--cari-primary);\n  outline-offset: 2px;\n}\n\n.cari-workspace :where(.form-control, .form-select) {\n  min-height: 40px;\n  border-radius: var(--cari-radius-control);\n  border-color: var(--cari-border-strong);\n}\n.cari-workspace :where(.form-control, .form-select):focus {\n  box-shadow: var(--cari-focus-ring);\n}\n.cari-workspace :where(.btn) {\n  min-height: 40px;\n  border-radius: var(--cari-radius-control);\n  font-weight: 600;\n  transition: background-color 150ms ease, border-color 150ms ease;\n}\n.cari-workspace :where(.btn-sm) { min-height: 32px; }\n.cari-workspace :where(.btn-lg) { min-height: 44px; }\n.cari-workspace :where(.btn-primary) {\n  --bs-btn-bg: var(--cari-primary);\n  --bs-btn-border-color: var(--cari-primary);\n  --bs-btn-hover-bg: var(--cari-primary-hover);\n  --bs-btn-hover-border-color: var(--cari-primary-hover);\n  --bs-btn-active-bg: var(--cari-primary-active);\n  --bs-btn-active-border-color: var(--cari-primary-active);\n  --bs-btn-disabled-bg: var(--cari-border);\n  --bs-btn-disabled-border-color: var(--cari-border);\n  --bs-btn-disabled-color: var(--cari-text-muted);\n}\n.cari-workspace :where(.btn-outline-primary) {\n  --bs-btn-color: var(--cari-primary);\n  --bs-btn-border-color: var(--cari-primary);\n  --bs-btn-hover-bg: var(--cari-primary);\n  --bs-btn-hover-border-color: var(--cari-primary);\n}\n.cari-workspace :where(.card, .panel) {\n  border-radius: var(--cari-radius-card);\n  border: 1px solid var(--cari-border);\n  box-shadow: var(--cari-shadow);\n}\n.cari-workspace :where(.modal-content) {\n  border-radius: var(--cari-radius-dialog);\n  border: 1px solid var(--cari-border);\n  box-shadow: var(--cari-shadow-lg);\n}\n.cari-workspace :where(.dropdown-menu, .popover) {\n  border-radius: var(--cari-radius-control);\n  border-color: var(--cari-border);\n  box-shadow: var(--cari-shadow-lg);\n}\n.cari-workspace :where(.badge) { border-radius: 999px; font-weight: 600; }\n.cari-workspace :where(.table) { --bs-table-color: var(--cari-text); border-color: var(--cari-border); }\n.cari-workspace :where(.table > thead th, .table > thead td) {\n  background: var(--cari-canvas);\n  color: #464C52;\n  font-weight: 600;\n  border-bottom: 1px solid var(--cari-border);\n}\n.cari-workspace :where(.table-hover > tbody > tr:hover > *) { background: var(--cari-primary-soft); }\n.cari-workspace :where(.form-check-input:checked, .progress-bar, .page-item.active .page-link) {\n  background-color: var(--cari-primary);\n  border-color: var(--cari-primary);\n}\n.cari-workspace :where(.form-check-input:focus) { box-shadow: var(--cari-focus-ring); }\n.cari-workspace :where(.page-link) { color: var(--cari-primary); }\n.cari-workspace :where(.page-item.active .page-link) { color: var(--cari-surface); }\n\n.cari-workspace ::-webkit-scrollbar { width: 8px; height: 8px; }\n.cari-workspace ::-webkit-scrollbar-thumb {\n  background: var(--cari-border-strong);\n  border-radius: 999px;\n  border: 2px solid transparent;\n  background-clip: content-box;\n}\n.cari-workspace ::-webkit-scrollbar-track { background: transparent; }\n\n/* Reports print in document flow, independently of the on-screen scroll viewport. */\n@media print {\n  html:has(.cari-workspace),\n  body:has(.cari-workspace),\n  #root:has(.cari-workspace) {\n    height: auto;\n    min-height: 0;\n    overflow: visible;\n  }\n  .cari-workspace.cari-workspace,\n  .cari-workspace > .workspace-row,\n  .cari-workspace > .workspace-row > .workspace-content,\n  .cari-workspace .workspace-content > .main-content {\n    position: static;\n    display: block;\n    width: 100%;\n    height: auto;\n    min-height: 0;\n    max-height: none;\n    overflow: visible;\n    background: #fff;\n  }\n  .cari-workspace > .workspace-row > :not(.workspace-content),\n  .cari-workspace .workspace-header,\n  .cari-workspace-floating {\n    display: none;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .cari-workspace.cari-workspace :where(*, *::before, *::after) {\n    animation-duration: 0.01ms;\n    animation-iteration-count: 1;\n    transition-duration: 0.01ms;\n    scroll-behavior: auto;\n  }\n}\n\n/*\n * 부트스트랩(reactstrap) 모달 틀. app.min.css 가 .modal-dialog 높이를 calc(100vh - 60px) 로\n * 고정(!important)하고 가운데 정렬해서, 내용이 화면보다 길면 위쪽이 잘리고 스크롤로도 올라갈 수 없었다.\n * 같은 값을 최소 높이로 바꿔 작은 모달은 지금 위치 그대로, 긴 모달은 틀이 늘어나 바깥이 스크롤되게 한다.\n */\n.modal-dialog {\n  height: auto !important;\n  min-height: calc(100vh - 60px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
